import React, { useRef } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material"
import SectionOutputsIngredientsForm from "./SectionOutputsIngredientsForm"
import { COLLECTION_NAMES, convertIdToPointer } from "../../../../../parseUtils"

const sx = {
  dialog: {
    " & .MuiDialog-paper": {
      display: "flex",
      flexDirection: "column",
      gap: "32px",
      padding: "32px",
      width: 700
    }
  }
}

const SectionOutputsIngredientsDialog = ({
  open,
  onClose,
  section,
  onSubmit,
}) => {
  const formikRef = useRef(null)

  const handleConfirm = () => {
    if (!formikRef.current) return
    formikRef.current.submitForm()
  }
  const handleSubmit = (values) => {
    onSubmit({
      ...values,
      sectionOutputs: values.sectionOutputs.map(output => ({
        ...output,
        ingredients: output.ingredients.map(ing => ({
          ...ing,
          supplierItem: convertIdToPointer(COLLECTION_NAMES.supplierItem, ing.supplierItem.id ?? ing.supplierItem.objectId)
        }))
      }))
    })
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth sx={sx.dialog}>
      <DialogTitle sx={{ p: 0, m: 0, fontSize: 16, fontWeight: 400, lineHeight: 1.375, color: "#7c7c7c" }}>
        Divisez votre section en répartissant les ingrédients dans chaque partie
        et attribuez-leur un nom.
      </DialogTitle>
      <DialogContent sx={{ px: 0 }}>
        <SectionOutputsIngredientsForm ref={formikRef} onSubmit={handleSubmit} section={section} />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", px: 0 }}>
        <Button onClick={onClose} variant="text">
          Retour
        </Button>
        <Button type="submit" variant="contained" color="primary" onClick={handleConfirm}>
          Valider
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SectionOutputsIngredientsDialog
